import {DICT_ARIA_RESOURCE_TEXT, DICT_DEFAULT_RESOURCE_TEXT} from "../utils/constants";
import {addOptionConfigToElCSS, buildUri, isDefinedAndNotNull} from "../utils/dom";

export default class FormComponent extends HTMLElement {
    #resourcesService;
    #intlTelInputFieldsData = [];

    constructor() {
        super();
    }

    init(resourcesService) {
        this.#resourcesService = resourcesService;
    }

    renderForm(customerInfo){
        
        //individual form elements
        customerInfo.forEach((formFieldData, index) => {

            // single form element
            const rowContainer = document.createElement("div");
            const labelContainer = document.createElement("div");
            const labelEl = document.createElement("label");
            labelEl.setAttribute("class", "scheduler-customerinfo-label");

            labelEl.innerHTML = formFieldData.link ? this.#createAnchor(formFieldData.name, formFieldData.link) : this.#resourcesService.getFormattedResource(formFieldData.name, 'SELFSCHEDULER_FORM', 'LABEL', formFieldData.name);
            
            let formFieldAriaLabel = formFieldData.name;
            let formFieldAriaRequired = this.#resourcesService.getResource("SELFSCHEDULER_ARIA_FORM_FIELD_REQUIRED", DICT_ARIA_RESOURCE_TEXT.SELFSCHEDULER_ARIA_FORM_FIELD_REQUIRED);
            if (parseInt(formFieldData.required) === 1) {
                formFieldAriaLabel = `${formFieldAriaLabel} ${formFieldAriaRequired}`;
                labelEl.appendChild(this.#createRequired());
            } 
            labelEl.setAttribute("aria-label", formFieldAriaLabel);
            

            labelEl.setAttribute("id", `v24SchedulerLabel-${index}`);
            labelContainer.appendChild(labelEl);
            rowContainer.appendChild(labelContainer);

            const inputContainer = document.createElement("div");
            inputContainer.setAttribute("class", "v24-scheduler-field v24-panel-registration");

            let formInputEl = this.#createFormField(formFieldData, index);

            if (isDefinedAndNotNull(formInputEl)) {
                //wrap elements add to layout
                inputContainer.appendChild(formInputEl);
                rowContainer.appendChild(inputContainer);
                if (isDefinedAndNotNull(labelEl)) {
                    formInputEl.setAttribute("aria-labelledby", labelEl.id);
                }
            }
            //if appendContent array exists, loop through items
            if (formFieldData.appendContent) {

                const divEl = document.createElement("div");
                divEl.setAttribute("class", "v24appendedContent");
                divEl.setAttribute("tabIndex", "0");
                formFieldData.appendContent.forEach(textToAppend => {
                    divEl.innerHTML += this.#resourcesService.getResource(textToAppend.value, textToAppend.value);
                });

                rowContainer.appendChild(divEl);
            }
            this.appendChild(rowContainer);
        });

        const showGDPR = this.#resourcesService.getResource("SELFSCHEDULER_SHOW_GDPR", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_SHOW_GDPR) === "1";
        if (showGDPR) {
            this.appendChild(this.#createGDPRNotice());
        }

        // once elements are in the DOM, loop through form and find any intl input fields
       this.#intlTelInputFieldsData.forEach((inputData) => {
            this.#initIntlTelInput(inputData);
        });
    }

    #createTelInput(index, fieldType, placeholder, options) {
        const inputEl = this.#createInput(index, fieldType, placeholder);
        inputEl.setAttribute("class", "v24-scheduler-customerinfo-input v24-intl-tel-input");
        let ariaLabel = this.#resourcesService.getResource("SELFSCHEDULER_ARIA_PHONE_NUMBER_INSTRUCTIONS", DICT_ARIA_RESOURCE_TEXT.SELFSCHEDULER_ARIA_PHONE_NUMBER_INSTRUCTIONS);
        inputEl.setAttribute("aria-label", ariaLabel);

        //push data into array for loading tel input field options when added to dom
        this.#intlTelInputFieldsData.push({
            "id": inputEl.id,
            "options": options
        });
        return inputEl;
    }
    
    #createRequired() {
        const requiredElement = document.createElement("span");
        requiredElement.setAttribute("class", "v24scheduler-required");
        requiredElement.innerHTML = this.#resourcesService.getResource("SELFSCHEDULER_REQUIRED", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_REQUIRED);
        return requiredElement;
    }

    #createAnchor(text, link){
        if(!text){
            console.warn("No text provided");
            return null;
        }

        if(!link){
            console.warn("No link provided");
            return null;
        }
        return `<a href='${link}' target='_blank'>${text}</a>`;
    }


    #createSelect(index, options) {

        if(!options){
            console.warn("No options available");
        }
        
        const selectEl = document.createElement("select");
        selectEl.setAttribute("id", `v24SchedulerElement-${index}`);
        selectEl.setAttribute("class", "v24-scheduler-customerinfo-input v24-scheduler-select");

        try {
            options.forEach(option => {
                const optionEl = document.createElement("option");
                optionEl.innerHTML = option;
                selectEl.appendChild(optionEl);
            });
        } catch (error) {
            console.warn("Error on Customer Form Dropdown Creation.", error);
        }
        return selectEl;
    }

    #createCheckbox(index, name, placeholder, mappedField) {
        const labelEl = document.createElement('label');
        labelEl.setAttribute('class', 'v24-scheduler-checkbox-label');
        
        const inputEl = this.#createInput(index, "checkbox", "");
        inputEl.classList.add("v24-scheduler-checkmark");
        inputEl.setAttribute("tabindex", "0");
        inputEl.setAttribute("role", "checkbox");
        inputEl.setAttribute("aria-checked", "false");
        inputEl.setAttribute("aria-labelledby", `v24SchedulerLabel-${index}`);
        
        // Add keyboard event handling
        inputEl.addEventListener("keydown", (e) => {
            if (e.key === " " || e.key === "Enter") {
                e.preventDefault();
                inputEl.click();
            }
        });
        
        // Update ARIA state on change
        inputEl.addEventListener("change", (e) => {
            inputEl.setAttribute("aria-checked", e.target.checked);
        });
        
        labelEl.appendChild(inputEl);
        const placeholderText = this.#resourcesService.getFormattedResource(name, 'SELFSCHEDULER_CHECKBOX', 'PLACEHOLDER', placeholder || '');
        if (placeholderText) {
            labelEl.append(placeholderText);
        }
        
        if (mappedField) {
            inputEl.dataset.mappedField = mappedField;
        }
        return labelEl;
    }

    #createTextArea(index, placeholder) {
        
        const textareaEl = document.createElement("textarea");
        textareaEl.setAttribute("id", `v24SchedulerElement-${index}`);
        textareaEl.setAttribute("class", "v24-scheduler-customerinfo-input");
        if (placeholder) {
            textareaEl.setAttribute("placeholder", placeholder)
        }

        return textareaEl;
    }

    #createInput(index, fieldType, placeholder, mappedField) {
        
        let el = document.createElement("input");
        el.setAttribute("id", `v24SchedulerElement-${index}`);
        el.setAttribute("type", fieldType);
        el.setAttribute("class", "v24-scheduler-customerinfo-input");
        if (placeholder) {
          el.setAttribute("placeholder", placeholder);
        }  
        if (mappedField) {
            el.dataset.mappedField = mappedField;
        }
        return el;
    }

    /**@private
     *Initiate International Telephone Input according to JSON options
     * @returns {Object} reference to InternationalNumberInput
     * @param data Array
     */
    #initIntlTelInput(data) {
        try {
                // Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
                const IS_MOBILE = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                const inputEl = this.querySelector(`#${data.id}`);
                const options = data.options || {};

                // to give ability to target CSS based on config used
                addOptionConfigToElCSS(inputEl, "v24-iti-allowDropdown-" + options.allowDropdown);
                addOptionConfigToElCSS(inputEl, "v24-iti-separateDialCode-" + options.separateDialCode);
                addOptionConfigToElCSS(inputEl, "v24-iti-nationalMode-" + options.nationalMode);

                return intlTelInput(inputEl, {
                    allowDropdown: options.allowDropdown !== "0", //toggle dropdown
                    autoHideDialCode: options.autoHideDialCode === "1",
                    dropdownContainer: IS_MOBILE ? inputEl.parentElement : '',
                    excludeCountries: options.excludeCountries || [], //['do'], // exclude countries (only works with full country list())
                    formatOnDisplay: options.formatOnDisplay !== "0", // formats numbers according to selected country
                    initialCountry: options.initialCountry || false, // preselects country
                    localizedCountries: options.localizedCountries || [], // adds countries into local language i.e. Deutschland rather than Germany
                    nationalMode: options.nationalMode === "1", //Allow users to enter national numbers (and not have to think about international dial codes)
                    onlyCountries: options.onlyCountries || [], // explicitly define allowed countries
                    placeholderNumberType: options.placeholderNumberType || "FIXED_LINE", // shows example mobile / fixed line number as placeholder
                    preferredCountries: options.preferredCountries || [], // adds these to the top of the list
                    separateDialCode: options.separateDialCode !== "0", // shows +XX country code next to flag, also drops first 0,
                    utilsScript: buildUri(v24Scheduler.staticDomain, "/v24/veedesk/self-scheduler/intl-tel-input/dist/js/utils.js"),
                    ariaLabel: options.ariaLabel
                });
        }
        catch(ex) {
            console.warn(`unable to create intl tel phone field, Charset is: ${document.characterSet}`);
            console.warn(ex);
        }
    }

    #createGDPRNotice() {
        let gdprElem = document.createElement("div");
        gdprElem.setAttribute("id", "v24-scheduler-gdpr");
        gdprElem.innerHTML = this.#resourcesService.getResource("SELFSCHEDULER_GDPR_CONTENT", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_GDPR_CONTENT);
        return gdprElem;
    }

    #createFormField(formFieldData, index) {

        //NOTE: placeHolder is the passed field from the server (not placeholder)
        let formInputEl;

        const fieldType = formFieldData.type.toLowerCase();

        switch (fieldType) {
            case "text": // fallthrough
            case "email": 
                formInputEl =  this.#createInput(index, fieldType, formFieldData.placeholder, formFieldData.mappedField);
                break;
            case "tel": //used to format intl drop down and number format
                formInputEl = this.#createTelInput(index, fieldType, formFieldData.placeHolder, formFieldData.options);
                break;
            case "note": 
                formInputEl = this.#createTextArea(index, formFieldData.placeholder);
                break;
            case "checkbox": 
                formInputEl = this.#createCheckbox(index, formFieldData.name, formFieldData.placeHolder, formFieldData.mappedField);
                break;
            case "choice": 
                formInputEl = this.#createSelect(index, formFieldData.options);
                break;
        }

        if (formFieldData.required === '1') {
            formInputEl.required = true;
        }

        return formInputEl;
    }
}